/* PERF: deferred past first paint via HRDefer (assets/hr-perf-core.js). Body unchanged. */
(window.HRDefer||function(f){if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){setTimeout(f,1)},{once:true})}else{setTimeout(f,1)}})(function(){

  /* HR cart-drawer fix (owner brief 2026-07-23): minus at qty 1 must REMOVE
     the line, same as the "Remove" link, not bounce back to 1. The drawer's
     qty <input> already allows stepping down to 0 (min="0" in the markup
     above; data-min carries the real Shopify quantity_rule.min), but Dawn's
     shared CartItems.validateQuantity (assets/cart.js, also used by the
     full /cart page) rejects any value below quantity_rule.min and resets
     the input, so the removal never fired. Patch ONLY the drawer's
     subclass (cart-drawer-items -> CartDrawerItems), leaving the /cart
     page's CartItems untouched: when the stepped value is 0, skip the
     min-rule validation and call the exact same updateQuantity(index, 0)
     path the Remove button uses. */
  customElements.whenDefined('cart-drawer-items').then(function () {
    var hrDrawerItemsProto = customElements.get('cart-drawer-items').prototype;
    var hrOriginalValidateQuantity = hrDrawerItemsProto.validateQuantity;
    hrDrawerItemsProto.validateQuantity = function (event) {
      var hrInputValue = parseInt(event.target.value, 10);
      if (hrInputValue === 0) {
        event.target.setCustomValidity('');
        /* HR mobile redesign 2026-07-30: minus-to-zero is a removal, so give it
           the same smooth row-collapse exit the Remove button gets. */
        if (window.hrCartCollapseRow) window.hrCartCollapseRow(event.target.closest('.cart-item'));
        this.updateQuantity(
          event.target.dataset.index,
          0,
          document.activeElement ? document.activeElement.getAttribute('name') : null,
          event.target.dataset.quantityVariantId
        );
        return;
      }
      hrOriginalValidateQuantity.call(this, event);
    };
  });

});

/* PERF: deferred past first paint via HRDefer (assets/hr-perf-core.js). Body unchanged. */
(window.HRDefer||function(f){if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){setTimeout(f,1)},{once:true})}else{setTimeout(f,1)}})(function(){

  /* HR mobile sheet motion (2026-07-30 mobile redesign, apple-design skill).
     1) Remove-item exit: the row collapses (height + opacity) the instant
        Remove or minus-to-zero is tapped, so the AJAX re-render lands on an
        already-settled list instead of the row vanishing in one hard jump.
     2) Swipe-down-to-close: direct manipulation on the sheet's header zone.
        1:1 tracking with the finger, rubber-band resistance above the rest
        position, velocity-projected release (Apple's momentum projection),
        transform-only, fully interruptible (the settle-back and the dismissal
        both run through the stylesheet's own interruptible transitions).
     Listeners are delegated at document level because Dawn's cart AJAX
     replaces #CartDrawer / .drawer__inner innerHTML wholesale on every update. */
  (function () {
    var mqMobile = window.matchMedia('(max-width: 749px)');
    var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* -- line-item exit ---------------------------------------------------- */
    window.hrCartCollapseRow = function (row) {
      if (!row || row.dataset.hrLeaving) return;
      row.dataset.hrLeaving = '1';
      row.style.overflow = 'hidden';
      row.style.height = row.getBoundingClientRect().height + 'px';
      void row.offsetHeight; /* commit the fixed height before transitioning */
      if (mqReduce.matches) {
        row.style.transition = 'opacity 140ms ease-out';
        row.style.opacity = '0';
      } else {
        row.style.transition =
          'height 300ms cubic-bezier(.32,.72,0,1), opacity 180ms ease-out, padding 300ms cubic-bezier(.32,.72,0,1), border-bottom-width 300ms cubic-bezier(.32,.72,0,1)';
        row.style.opacity = '0';
        row.style.height = '0px';
        row.style.paddingTop = '0px';
        row.style.paddingBottom = '0px';
        row.style.borderBottomWidth = '0';
      }
      /* Failsafe: if the cart update errors and never re-renders, restore. */
      setTimeout(function () {
        if (row.isConnected && row.dataset.hrLeaving) {
          row.style.cssText = '';
          delete row.dataset.hrLeaving;
        }
      }, 4000);
    };
    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest && e.target.closest('#CartDrawer cart-remove-button .hr-remove');
        if (!btn) return;
        window.hrCartCollapseRow(btn.closest('.cart-item'));
      },
      true
    );

    /* -- swipe-down to close ------------------------------------------------ */
    var hrDrag = null;
    document.addEventListener(
      'pointerdown',
      function (e) {
        if (!mqMobile.matches || mqReduce.matches) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (!e.target.closest) return;
        var host = document.querySelector('cart-drawer');
        if (!host || !host.classList.contains('active')) return;
        var inner = host.querySelector('.drawer__inner');
        if (!inner) return;
        var zone = e.target.closest('#CartDrawer .drawer__header');
        /* BUILD 1 (2026-07-30): the grabber pill is a ::before on
           `.drawer__inner`, so a finger landing on it hit-tests to the sheet
           itself and the gesture never started -- the one piece of the sheet
           that LOOKS draggable was the one piece that was not. Treat the top
           strip of the sheet (grabber band, above the title's baseline) as part
           of the same zone. Bounded by the sheet's own top edge, so it can
           never swallow a swipe further down the scrolling content. */
        if (!zone && e.target === inner && e.clientY - inner.getBoundingClientRect().top <= 52) {
          zone = inner;
        }
        /* BUILD 2 (2026-07-30) — WHY THE DRAG ZONE STAYS THE HEADER/GRABBER,
           and is NOT extended to the whole sheet.
           Real-touch testing showed the gap: once the sheet is scrolled the
           header is off-screen, so an iOS-style "pull down from anywhere while
           the scroll view is at the top" was implemented and measured. It does
           not survive the browser: with a directional lock (arm on pointerdown,
           commit only past 6px of downward movement, never capture the pointer
           until then), the traced sequence on a real touch drag is

             pointerdown y529 -> pointermove y544 -> pointermove y559
             (transform translateY(15.05px) applied) -> POINTERCANCEL

           i.e. the engine claims the touch for panning `.drawer__inner` and
           cancels the pointer two frames in, every time. The only way to win
           that is `touch-action:none` on the sheet (which kills its scrolling
           outright) or a non-passive document `touchmove` + preventDefault,
           which de-optimises scrolling for the whole page while the cart is
           open. CLAUDE.md section 0 is explicit: performance beats effect and
           motion must never fight native scroll, so neither is worth a
           secondary gesture.
           What the shopper gets instead, all verified by real touch:
             - swipe down on the header/grabber band (`touch-action:none`, so the
               engine never claims it) -> dismisses, velocity-projected;
             - a STICKY close chip that stays on screen at every scroll offset
               (measured y:66 at scrollTop 335), so dismissal is always one tap;
             - scrim tap, and hardware/browser back. */
        if (!zone || e.target.closest('button, a, input, select, textarea')) return;
        /* interruptibility: start from the live presentation value */
        var mtx = new DOMMatrixReadOnly(getComputedStyle(inner).transform);
        hrDrag = {
          id: e.pointerId,
          startY: e.clientY,
          baseY: mtx.m42 || 0,
          lastY: e.clientY,
          lastT: e.timeStamp,
          v: 0,
          inner: inner
        };
        inner.style.transition = 'none';
        try { zone.setPointerCapture(e.pointerId); } catch (err) {}
      },
      { passive: true }
    );
    document.addEventListener('pointermove', function (e) {
      if (!hrDrag || e.pointerId !== hrDrag.id) return;
      var dt = e.timeStamp - hrDrag.lastT;
      if (dt > 0) hrDrag.v = ((e.clientY - hrDrag.lastY) / dt) * 1000;
      hrDrag.lastY = e.clientY;
      hrDrag.lastT = e.timeStamp;
      var dy = hrDrag.baseY + (e.clientY - hrDrag.startY);
      if (dy < 0) dy = -Math.min(24, Math.pow(-dy, 0.72)); /* rubber-band upward */
      hrDrag.inner.style.transform = 'translateY(' + dy + 'px)';
    });
    /* Abort a drag that is being cut short by something else closing the sheet
       (X tap, scrim tap, hardware back, an AJAX re-render). Without this the
       inline transform written by the last pointermove survived the close and
       the sheet re-opened parked at that offset. Called from
       assets/cart-drawer.js close(). */
    window.hrCartCancelDrag = function () {
      if (!hrDrag) return;
      var inner = hrDrag.inner;
      hrDrag = null;
      inner.style.transition = '';
      inner.style.transform = '';
    };

    function hrEndDrag(e) {
      if (!hrDrag || (e && e.pointerId !== hrDrag.id)) return;
      var inner = hrDrag.inner;
      var v = hrDrag.v;
      hrDrag = null;
      var mtx = new DOMMatrixReadOnly(getComputedStyle(inner).transform);
      var y = mtx.m42 || 0;
      /* hand back to the stylesheet's interruptible transition, which starts
         from the current on-screen value */
      inner.style.transition = '';
      inner.style.transform = '';
      /* momentum projection (decelerationRate .998) decides commit vs settle */
      var projected = y + ((v / 1000) * 0.998) / (1 - 0.998);
      var host = document.querySelector('cart-drawer');
      if (host && (projected > inner.getBoundingClientRect().height * 0.35 || v > 950)) {
        host.close();
      }
    }
    document.addEventListener('pointerup', hrEndDrag);
    document.addEventListener('pointercancel', hrEndDrag);
  })();

});
